import { modelsCompFn } from '@/lib/filter/base-frontend-filter/scope';

export const directGoalCyclesFn = ({ entity, scope }) => {
  const models = entity[scope.directProperty.edgeName];
  const neededModels = scope.goalCycles || [];
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};
